import { CheckIcon } from "lucide-react";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";

const EqualDivisionSection = ({
  title,
  heading,
  description,
  checks,
  image = "",
  video = "",
  bgColor,
  imageRight = true,
  opinion,
  imageRounded = true,
  leftDivStyle = "",
}) => {
  return (
    <div className={`${bgColor} py-7 md:py-32 transition-all duration-700`}>
      <div
        className={`max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 xl:gap-20 items-start ${leftDivStyle}`}
      >
        <div className={`${imageRight ? "md:order-1" : "md:order-2"} order-1`}>
          {title && (
            <p className="uppercase text-purple-900 mb-2 text-xs md:text-base font-semibold">
              {title}
            </p>
          )}
          <p
            className={`${
              bgColor == "bg-dark" ? "text-white" : ""
            } text-[28px]  md:text-4xl xl:text-5xl font-semibold text-start ${
              heading && "mb-6"
            }`}
          >
            {heading}
          </p>
          {description && (
            <p
              className={`${
                bgColor == "bg-dark" ? "text-white" : "text-gray-900"
              } mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left`}
            >
              {description}
            </p>
          )}
          <ul
            className={`space-y-4 ${
              bgColor == "bg-dark" ? "text-white" : "text-gray-800"
            } text-lg md:leading-none xl:leading-relaxed`}
          >
            {checks.map((check, idx) => (
              <li className="flex items-start text-start" key={idx}>
                <CheckIcon className="w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0" />
                {check}
              </li>
            ))}
          </ul>
          {opinion && (
            <p
              className={`${
                bgColor == "bg-dark" ? "text-white" : "text-black"
              } mb-6  md:text-base w-[70%] pl-4 font-semibold font-medium mt-10 text-start hidden md:block`}
            >
              {opinion}
              <br />
              <span>-BoloSign User</span>
            </p>
          )}
        </div>

        {/* Image Section */}
        <div
          className={`bg-color  rounded-2xl relative  ${
            imageRight ? "order-2" : "order-1"
          }`}
        >
          {image && (
            <Image
              src={image}
              alt="Contract Creation"
              width={500}
              height={500}
              className={`w-full ${imageRounded ? "rounded-2xl" : ""}`}
            />
          )}
          {video && (
            <video
              src={video}
              autoPlay
              muted
              loop
              className="w-full h-full object-cover rounded-2xl"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EqualDivisionSection;
